<template>
  <article :style="cssVariables">
    <header class="header">
      <nav>
        <btn-menu v-if="!$forSize['desktop-up']" color="var(--on-primary)"/>
        <figure class="home-logo"/>
        <routes v-if="$forSize['desktop-up']" color="var(--on-primary)" highlightColor="transparent"/>
        <div v-if="$config.featureFlags['EXIBIR_BOTAO_ENTRAR']" class="login-btn-container">
          <span v-html="$config.strings['header-btn-6']" />
          <t-button
            backgroundColor="var(--secondary)"
            color="var(--on-secondary)"
            size="lg"
            raised
            rounded
            @click="loginRedirect"
            v-html="$config.strings['header-btn-7']"
          >
          </t-button>
        </div>
      </nav>
      <img class="image" :src="$config.images['HOME_RASPADINHA_IMAGE']"/>
      <section class="description">
        <img class="product-logo" :src="$config.images['HOME_RASPADINHA_PRODUCT_LOGO']"/>
        <h1 class="description-title" v-html="$config.strings['HOME_RASPADINHA_DESCRIPTION_TITLE']"/>
        <p class="description-text" v-html="$config.strings['HOME_RASPADINHA_DESCRIPTION_TEXT']"/>
        <t-button
          v-if="$config.strings['HOME_RASPADINHA_DESCRIPTION_BUTTON']"
          backgroundColor="var(--secondary)"
          color="var(--on-secondary)"
          size="lg"
          raised
          rounded
          @click="raspadinhaRedirect"
          v-html="$config.strings['HOME_RASPADINHA_DESCRIPTION_BUTTON']"
        >
        </t-button>
      </section>
    </header>
    <main>
      <div>
        <section class="section-03">
          <h1 class="section-title" v-html="$config.strings['HOME_RASPADINHA_SECTION_03_TITLE']"/>
          <img v-if="$forSize['desktop-up']" :src="$config.images['HOME_RASPADINHA_PRODUCT_SECTION_03']"/>
          <img class="section-03-image-mobile" v-else :src="$config.images['HOME_RASPADINHA_PRODUCT_SECTION_03_MOBILE']"/>
          <t-button
            backgroundColor="var(--secondary)"
            color="var(--on-secondary)"
            size="lg"
            raised
            rounded
            @click="$router.push('/cadastrar')"
            v-html="$config.strings['HOME_RASPADINHA_SECTION_03_BUTTON']"
          ></t-button>
        </section>
        <section class="section-01">
          <h1 class="section-title" v-html="$config.strings['HOME_RASPADINHA_SECTION_01_TITLE']"/>
          <img v-if="$forSize['desktop-up']" :src="$config.images['HOME_RASPADINHA_PRODUCT_SECTION_01']"/>
          <img v-else :src="$config.images['HOME_RASPADINHA_PRODUCT_SECTION_01_MOBILE']"/>
          <t-button
            backgroundColor="var(--secondary)"
            color="var(--on-secondary)"
            size="lg"
            raised
            rounded
            @click="$router.push('/regulamento')"
            v-html="$config.strings['HOME_RASPADINHA_SECTION_01_BUTTON']"
          ></t-button>
        </section>
        <section class="section-02">
          <h1 class="section-title" v-html="$config.strings['HOME_RASPADINHA_SECTION_02_TITLE']"/>
          <Accordion
            :items="faq"
            title-color="var(--on-home-raspadinha-background)"
            content-color="var(--on-home-raspadinha-background)"
          />
        </section>
      </div>
    </main>
    <t-footer backgroundColor="var(--background)" color="var(--on-background)" logoColor="var(--on-background)"/>
  </article>
</template>

<script>
import Routes from '@/components/common/Routes'
import TButton from '@/components/base/TButton'
import Accordion from '@/components/Accordion'
import BtnMenu from '@/components/common/MenuButton'
import TFooter from '@/components/base/TFooter'

export default {
  name: 'PageHomeRaspadinha',
  components: {
    Routes,
    TButton,
    Accordion,
    TFooter,
    BtnMenu
  },
  methods: {
    loginRedirect () {
      location.href = this.$config.urls.login_url
    },
    raspadinhaRedirect () {
      location.href = this.$config.urls.rapadinha_url
    }
  },
  computed: {
    cssVariables () {
      return {
        '--home-logo': `url(${this.$config.images['HOME_RASPADINHA_LOGO']})`,
        '--background-img': `url(${this.$config.images['HOME_RASPADINHA_BACKGROUND']})`
      }
    },
    faq () {
      const questions = {}
      const answers = {}
      Object.keys(this.$config.strings).forEach(key => {
        if (/^faq-question-\d+$/.test(key)) {
          const index = Number(key.replace(/^faq-question-/, ''))
          questions[index] = this.$config.strings[key]
        }
        if (/^faq-answer-\d+$/.test(key)) {
          const index = Number(key.replace(/^faq-answer-/, ''))
          answers[index] = this.$config.strings[key]
        }
      })
      const items = Object.keys(questions).map(index => {
        return {
          title: questions[index],
          content: answers[index]
        }
      })
      return items
    }
  }

}
</script>

<style lang="scss" scoped>
article {
  color: var(--on-primary);
  background-color: var(--home-raspadinha-background);
  .header {
    background: var(--background-img);
    background-position: bottom center;
    background-size: cover;
    background-repeat: no-repeat;
    padding: 26px;
    display: grid;
    grid-auto-columns: minmax(0, 1fr);
    grid-template-areas:
      "nav"
      "description"
      "figure";
    @include for-size(desktop-up) {
      padding: 60px 10% 180px 10%;
      grid-template-areas:
      "nav nav"
      "figure description";
    }
    nav {
      grid-area: nav;
      display: flex;
      align-items: center;
      height: 66px;
      justify-content: space-between;

      @include for-size(desktop-up) {
        justify-content: right;
      }
      .home-logo {
        background: var(--home-logo);
        background-position: left center;
        background-size: contain;
        background-repeat: no-repeat;
        width: 100%;
        height: 100%;
        max-height: 61px;
        max-width: 197px;

        @include for-size(desktop-up) {
          max-height: unset;
          max-width: unset;
        }
      }
      .login-btn-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-left: 13px;
        flex-shrink: 0;
      }
    }

    .image {
      object-fit: contain;
      grid-area: figure;
      width: 100%;
      max-height: 400px;
      margin-top: 20px;

      @include for-size(desktop-up) {
        max-height: 716px;
        margin-top: 100px;
      }
    }

    .description {
      margin-top: 100px;
      grid-area: description;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      .product-logo {
        object-fit: contain;
        max-width: 202px;
        max-height: 107px;
        margin-bottom: 20px;

        @include for-size(desktop-up) {
          max-width: 418px;
          max-height: 223px;
          margin-bottom: 40px;
        }
      }
      .description-title {
        text-align: left;
        font-size: 22px;
        margin-bottom: 16px;
        ::v-deep b {
          font-size: 22px;
        }

        @include for-size(desktop-up) {
          font-size: 45px;
          margin-bottom: 24px;
          ::v-deep b {
            font-size: 45px;
          }
        }

      }
      .description-text {
        text-align: left;
        font-size: 14px;
        margin-bottom: 24px;
        ::v-deep b {
          font-size: 14px;
        }

        @include for-size(desktop-up) {
          font-size: 21px;
          margin-bottom: 46px;
          ::v-deep b {
            font-size: 21px;
          }
        }
      }
    }
  }
  main {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    img {
      object-fit: contain;
      max-height: 583px;

      @include for-size(desktop-up) {
        max-height: 413px;
      }
    }
    .section-01, .section-02, .section-03 {
      color: var(--primary);
      display: flex;
      flex-direction: column;
      margin-bottom: 32px;
      button {
        align-self: center;
      }
      .section-title {
        font-size: 30px;
        font-weight: bold;
        margin-bottom: 40px;
        text-align: center;

        @include for-size(desktop-up) {
          text-align: left;
        }
      }
      .section-03-image-mobile {
        margin: 6% 12%;
      }
    }
  }
}
</style>
